<template>
  <main>
    <v-row>
      <v-col cols="12" md="6" lg="6">
        <v-autocomplete
          clearable
          multiple
          chips
          small-chips
          deletable-chips
          :items="excludes"
          item-text="name"
          item-value="id"
          dense
          :label="$t('fields.excludes')"
          outlined
          v-model="form.excludes"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6" lg="6">
        <v-autocomplete
          clearable
          multiple
          chips
          small-chips
          deletable-chips
          :items="includes"
          item-text="name"
          item-value="id"
          dense
          :label="$t('fields.includes')"
          outlined
          v-model="form.includes"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6" lg="6">
        <v-autocomplete
          clearable
          multiple
          chips
          small-chips
          deletable-chips
          :items="conditions"
          item-text="name"
          item-value="id"
          dense
          :label="$t('fields.conditions')"
          outlined
          v-model="form.conditions"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6" lg="6">
        <v-autocomplete
          clearable
          multiple
          chips
          small-chips
          deletable-chips
          :items="needs"
          item-text="name"
          item-value="id"
          :label="$t('fields.needs')"
          dense
          outlined
          v-model="form.needs"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-combobox
              multiple
              chips
              small-chips
              deletable-chips
              dense
              outlined
              v-model="form.available_dates"
              :label="$t('fields.available_dates')"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              clearable
              v-on="on"
            ></v-combobox>
          </template>
          <v-date-picker
            multiple
            v-model="form.available_dates"
            no-title
            scrollable
          >
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-divider />
  </main>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";
export default {
  name: "ThirdStep",

  props: {
    form: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      menu: null,
      conditions: [],
      includes: [],
      excludes: [],
      needs: []
    };
  },
  inject: ["$v"],

  methods: {
    handleGetFeatures() {
      const fields = [
        { name: "needs", type: 2 },
        { name: "conditions", type: 3 }
      ];
      for (const field of fields) {
        IndexData({
          reqName: `features?type=${field.type}`,
          query: { pagination: "all" }
        }).then(res => {
          const { features } = res.data;
          this[field.name] = features;
        });
      }
      IndexData({
        reqName: `features?type=1`,
        query: { pagination: "all" }
      }).then(res => {
        const { features } = res.data;
        this.includes = features;
        this.excludes = features;
      });
    }
  },
  watch: {
    $route: {
      handler() {
        this.handleGetFeatures();
      },
      immediate: true
    }
  }
};
</script>
